// Module
var code = `<template>
  <require from="./customer-name-widget.scss"></require>

  <!-- beautify ignore:start -->
  <style>
    .customer-name-widget-\${id} {
      font-family: \${font || 'var(--dyn-default-font-family)'};
      font-size: \${fontSize ? fontSize + 'px' : 'var(--dyn-default-font-size)'};
      color: \${color | widgetTemplateColor:isInDashboard} !important;
      text-align: \${textAlign || 'left'};
    }
  </style>
  <!-- beautify ignore:end -->

  <div class="customer-name-widget customer-name-widget-\${id}">\${customerService.selectedCustomer.name}</div>
</template>
`;
// Exports
export default code;